export default "__VITE_ASSET__D4ec4de2__"